"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchStrategy = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } /*
 * Copyright (c) 2022, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * @private
 */
class FetchStrategy extends _react.default.Component {
  /**
   * @private
   */
  static initAppState(args) {
    var _this = this;
    return _asyncToGenerator(function* () {
      try {
        const promises = _this.getInitializers().map(fn => fn(args));
        return {
          error: undefined,
          appState: _extends({}, ...(yield Promise.all(promises)))
        };
      } catch (error) {
        return {
          error: error || new Error(),
          appState: {}
        };
      }
    })();
  }
}
exports.FetchStrategy = FetchStrategy;